<template>
  <!-- 登录页 -->
  <div class="container">
    <div class="content">
    <!-- <div class="fixed"></div> -->
      <!-- 头部 -->
      <div class="content_top">
        <!-- <span class="adress">北京市房山区</span> -->
        <div class="title_box">
<!--          <span class="title">新乡市</span>-->
          <span class="title">{{ title }}{{ subTitle }}</span>
        </div>
        <div class="main">
          <ul class="nav">
            <li v-for="(item, index) in role" :key="index" :class="active === index ? 'active' : ''"
              @click="changeRole(index)">
              <img src="../assets/images/studentIcon.png" alt="" v-show="index == 0">
              <img src="../assets/images/parentIcon.png" alt="" v-show="index == 1">
              <img src="../assets/images/teacherIcon.png" alt="" v-show="index == 2">
              <img src="../assets/images/schoolLeaderIcon.png" alt="" v-show="index == 3">
              <img src="../assets/images/leaderIcon.png" alt="" v-show="index == 4">
              <span>{{ item }}</span>
            </li>
          </ul>
          <div class="login">
            <p class="title">请输入{{ role[active] }}登录账号</p>
            <span>如您忘记帐号，可联系学校</span>
            <el-input class="username" v-model="userName" placeholder="请输入账号"></el-input>
            <el-button type="primary" class="loginBtn" @click="login">登录</el-button>
          </div>
        </div>
      </div>
      <!-- 底部icon跳转官网 -->
      <div class="content_bottom" @click="goWebsite">
        <span class="bottom_title">技术支持</span>
        <img class="icon" src="../assets/images/logo.png" alt="" />
      </div>
    </div>
    <div class="loginBg">
      <div class="loginTitle">
        <a href="https://videos.ydassess.com/">生命安全与健康成长学习平台入口</a>
      </div>
    </div>

    <el-dialog class="dialog" :visible.sync="dialogVisible">
      <h2>手机号：</h2>
      <el-input type="tel" class="phone" v-model="phone" placeholder="请输入手机号"></el-input><br />
      <div class="messageCode">
        <h2>验证码：</h2>
        <el-input type="text" class="code" v-model="code" placeholder="请输入验证码"></el-input>
        <el-button v-show="isGetCode" class="getcode" @click="getCode">获取验证码</el-button>
        <el-button v-show="!isGetCode" class="getcode">{{ time }}s</el-button>
      </div>
      <div class="btnGroup">
        <el-button @click="login">登录</el-button>
        <el-button @click="dialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
import md5 from "js-md5";
import {
  studentLogin,
  codeNum,
  paramsLogin,
  teacherLogin,
  schoolLeaderLogin,
  regionLeaderLogin,
  adminLogin
} from "../api/loginApi";
// 定制化登陆页面
import login from '../js/login'
export default {
  name: "login",
  data() {
    return {
      role: ["学生", "家长", "教师", "校长/集团校", "地市/区县"],
      userName: "",
      passWord: "",
      phone: "",
      code: "",
      active: 0, // 控制高亮
      dialogVisible: false, // 控制弹框的显示隐藏
      menuData: "",
      time: 60,
      isGetCode: true,

      title: "中小学生生命健康",
      subTitle: "智慧教育平台",
      marketTitle: "中小学生生命健康智慧教育平台",

      Account_Splicing:'',//学生登录账号过于长，账号拼接使用 this.$route.query.Account_Splicing
    };
  },
  mounted() {
    // login.sendThis(this)
    // console.log(this.$store.state.login.title)
    // this.title = this.$store.state.login.title
    // this.marketTitle = this.$store.state.login.marketTitle

    // 截取链接所携带参数 作为学生登录的用户名拼接
    console.log('route',this.$route.query.Account_Splicing)
    if(this.$route.query.Account_Splicing){
      this.userName = this.$route.query.Account_Splicing
    }

  },
  methods: {
    ...mapMutations("Aside", ["addToMenu"]),
    // 切换角色时 高亮显示
    changeRole(index) {
      this.active = index;
      if(this.role[index]=='学生'&&this.$route.query.Account_Splicing){
        this.userName = this.$route.query.Account_Splicing
      }else{
        this.userName = ''
      }
      this.passWord = "";
    },
    // 获取验证码
    getCode() {
      let reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (!reg_tel.test(this.phone)) {
        this.$message.error("手机号格式错误，请您重新输入");
        return;
      }
      codeNum({
        phoneNo: this.phone,
        type: 3
      }).then(res => {
        console.log(res);
        if (res.data.code == 200) {
          this.isGetCode = false;
          let timer = setInterval(() => {
            if (this.time == 0) {
              clearInterval(timer);
              this.isGetCode = true;
            }
            this.time--;
          }, 1000);
          this.time = 60;
        }else{
          this.$message.error(res.data.message);
        }
      });
      // return;

    },

    // 跳转到官网
    goWebsite() {
      window.open("http://ydassess.com/", "_self");
    },

    // 家长端确定登陆
    // 点击了登录按钮
    login() {
      // 学生登陆
      if (this.active === 0) {
        this.userName = this.Account_Splicing + this.userName
        if(this.userName.length!==18){
          this.$message({
              message: '账号输入有误，请仔细核对',
              type: "error"
            });
            return
        }
        studentLogin({
          loginId: this.userName,
        }).then(res => {
          // debugger
          console.log(res);
          // res.data = JSON.parse(res.data);
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: "success"
            });
            if (this.userName == '513401130388810946') {
              res.data.data.roleId = this.userName
            }
            sessionStorage.setItem("userInfo", JSON.stringify(res.data.data));
            sessionStorage.setItem("accessToken", res.data.data.accessToken);
            sessionStorage.setItem("TGT", res.data.data.tgt);
            this.$router.push("/home");
          } else {
            this.$message.error(res.data.message);
          }
        })
      }
      // 家长登陆
      else if (this.active == 1) {
        paramsLogin({
          loginId: this.userName,
          phoneNumber: this.phone,
          verifyCode: this.code
        }).then(res => {
          console.log(res.data);
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: "success"
            });

            // 放置假数据
            if (this.userName == '513401130388810946') {
              let parentData = {
                gradeId: 6
              }
              res.data.data.roleId = this.userName
              sessionStorage.setItem('parentData', JSON.stringify(parentData))
            }

            sessionStorage.setItem("userInfo", JSON.stringify(res.data.data));
            sessionStorage.setItem("accessToken", res.data.data.accessToken);
            sessionStorage.setItem("TGT", res.data.data.tgt);
            this.$router.push("/home");
          } else {
            this.$message.error(res.data.message);
            this.dialogVisible = true;
          }
        });
        // 教师登陆
      }
      // 教师登陆
      else if (this.active == 2) {
        // debugger
        teacherLogin({
          loginId: this.userName
        }).then(res => {
          // res.data = JSON.parse(res.data);
          console.log(res.data);
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: "success"
            });

            // 放置假数据
            res.data.data.id = this.userName == '10764' ? '5134012131' : res.data.data.id

            sessionStorage.setItem("userInfo", JSON.stringify(res.data.data));
            sessionStorage.setItem("accessToken", res.data.data.accessToken);
            sessionStorage.setItem("TGT", res.data.data.tgt);
            this.$router.push("/home");
          }
        });
        // 校领导登陆
      }
      // 校长 集团校
      else if (this.active == 3) {
        schoolLeaderLogin({
          loginId: this.userName
        }).then(res => {
          // res.data = JSON.parse(res.data);
          console.log(res.data);
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: "success"
            });

            // 放置假数据
            // 普通校
            if (this.userName == '11010832024') {
              res.data.data.schoolId = '5134010001'
              let schoolName = 'XXX学校'
              let legendData = ['XXX学校', 'XX市']
              let legendData1 = ['XXX学校', '全国']
              sessionStorage.setItem('legendData', JSON.stringify(legendData))
              sessionStorage.setItem('legendData1', JSON.stringify(legendData1))
              sessionStorage.setItem('schoolName', schoolName)
            }

            // 集团校
            if (this.userName == '2308043311070') {
              let groupData = {
                schoolList: [
                  {
                    label: '测试学校',
                    value: '5134010016',
                    children: [
                      {
                        name: '三年级',
                        label: '3',
                        value: 1
                      },
                      {
                        name: '五年级',
                        label: '5',
                        value: 2,
                      }
                    ]
                  },
                  {
                    label: '测试学校2',
                    value: '5134010005',
                    children: [
                      {
                        name: '三年级',
                        label: '3',
                        value: 1,
                      },
                      {
                        name: '四年级',
                        label: '4',
                        value: 2,
                      }
                    ]
                  },
                  {
                    label: '测试学校3',
                    value: '5134010009',
                    children: [
                      {
                        name: '三年级',
                        label: '3',
                        value: 1,
                      },
                      {
                        name: '五年级',
                        label: '5',
                        value: 2,
                      }
                    ]
                  },
                ],
                gradeList: [
                  {
                    label: '三年级',
                    schoolGradeName: 3,
                  },
                  {
                    label: '四年级',
                    schoolGradeName: 4,
                  },
                  {
                    label: '五年级',
                    schoolGradeName: 5,
                  },
                ],
                groupSchoolId: "513400",
              }
              sessionStorage.setItem('groupData', JSON.stringify(groupData))
            }



            sessionStorage.setItem("userInfo", JSON.stringify(res.data.data));
            sessionStorage.setItem("accessToken", res.data.data.accessToken);
            sessionStorage.setItem("TGT", res.data.data.tgt);
            this.$router.push("/home");
          }
        });
      }
      // 区县
      else if (this.active == 4) {
        regionLeaderLogin({
          loginId: this.userName
        }).then(res => {
          // res.data = JSON.parse(res.data);
          console.log(res.data);
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: "success"
            });


            // 放置假数据
            if (this.userName == '110108422') {
              let leaderData = {
                // 省市区 code
                provinceLive: [
                  {
                    label: '四川省',
                    value: 510000,
                    children: [
                      {
                        label: '凉山彝族自治州',
                        value: 513400,
                        children: [
                          {
                            label: '西昌市',
                            value: 513401,
                            children: [
                              {
                                label: '测试学校1',
                                value: '5134012282'
                              },
                              {
                                label: '测试学校2',
                                value: '5134014704'
                              },
                            ]
                          },
                        ]
                      }
                    ]
                  }
                ],
                schoolList: [
                  {
                    label: '测试学校',
                    value: '5134015167'
                  },
                  {
                    label: '测试学校2',
                    value: '5134016152'
                  },
                  {
                    label: '测试学校3',
                    value: '5134018022'
                  },
                ],
                gradeList: [
                  {
                    label: '三年级',
                    schoolGradeName: 3,
                  },
                  {
                    label: '四年级',
                    schoolGradeName: 4,
                  },
                  {
                    label: '五年级',
                    schoolGradeName: 5,
                  },
                ],
                category: ['xx市', '全国'],
                regionName: 'xx市'
              }
              sessionStorage.setItem('leaderData', JSON.stringify(leaderData))
            }

            sessionStorage.setItem("userInfo", JSON.stringify(res.data.data));
            sessionStorage.setItem("accessToken", res.data.data.accessToken);
            sessionStorage.setItem("TGT", res.data.data.tgt);
            this.$router.push("/home");
          }
        });
      }
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  position: relative;
  height: 100vh;
  display: flex;
  background-color: #162a78;

  .content {
    padding-top: 0.5rem;
    padding-bottom: 0.1389rem;
    box-sizing: border-box;
    width: 45%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    position: relative;
    background-color:rgba(255, 255, 255, .9);
    // border: 1px solid red;
    .content_top {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      // border: 1px solid red;
      .adress {
        font-size: 0.125rem;
        margin-bottom: 0.1389rem;
      }

      .title_box {
        margin-bottom: 0.1389rem;
        // margin-left: 1.0417rem;
        display: flex;
        flex-direction: column;
        align-items: center;

        // border: 1px solid red;
        .title {
          display: block;
          font-size: 0.1667rem;
          color: #000;
          margin-bottom: .1389rem;
        }
      }

      .main {
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        // margin-top: .2778rem;
        box-shadow: 0rem 0rem .0694rem .0694rem #e4e6fc;
        border-radius:.1389rem;
        // padding: .1042rem;

        // 左侧 角色菜单
        .nav {
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          box-sizing: border-box;
          color: #000;
          // padding:5px;

          & li {
            // margin-left: .0694rem;
            margin-right: 0.0694rem;
            margin-bottom: 0.0694rem;
            width: 1.0417rem;
            height: 0.2778rem;
            line-height: 0.2778rem;
            text-align: center;
            font-size: 0.1111rem;
            // border: 1px solid #d9221a;
            background-color: rgba(255, 255, 255, .3);
            border-radius: 0.0208rem;
            font-family: Source Han Sans CN;
            font-weight: 400;
            display: flex;
            align-items: center;
            box-sizing: border-box;
            padding-left: .1042rem;
            // justify-content: center;
            cursor: pointer;
            border-radius:.0694rem;

            img {
              height: .1389rem;
              width: .1389rem;
              margin-right: .0694rem;
            }
          }

          & li:last-child {
            margin-bottom: 0rem;
          }
        }

        // 右侧 账号密码区域
        .login {
          padding-top: 0.3125rem;
          box-sizing: border-box;
          width: 2.7778rem;
          height: 2rem;
          // border: 1px solid #d9221a;
          // box-shadow: 0 0 0 5px rgb(170, 170, 170, 0.3) spread;
          background-color: rgba(255, 255, 255,.5);
          border-radius: 0.0694rem;
          display: flex;
          flex-direction: column;
          align-items: center;

          .title {
            font-size: 0.1389rem;
            margin-bottom: 0.0764rem;
          }

          span {
            margin-bottom: 0.1389rem;
            color: #999999;
            font-size: 0.0972rem;
          }

          .username {
            box-sizing: border-box;
            width: 1.5278rem;
            height: 0.2778rem;
            line-height: 0.2778rem;
            font-size: 0.1111rem;

            /deep/ .el-input__inner {
              padding: 0rem 0.0625rem;
            }
          }

          .password {
            margin-top: 0.0556rem;
            box-sizing: border-box;
            width: 1.5278rem;
            height: 0.2778rem;
            line-height: 0.2778rem;
            font-size: 0.1111rem;

            /deep/ .el-input__inner {
              padding: 0rem 0.0625rem;
            }
          }

          .loginBtn {
            margin-top: 0.1389rem;
            width: 1.5278rem;
            height: 0.2778rem;
            // background: #999;
            border-radius: 0.0208rem;
            color: #000;
            font-size: 0.1111rem;
          }
        }
      }
    }

    .content_bottom {
      width: 100%;
      height: 0.2778rem;
      // border: 1px solid red;
      display: flex;
      justify-content: center;
      align-items: center;
      user-select: none;
      cursor: pointer;

      .bottom_title {
        font-size: .0694rem;
        margin-right: .0694rem;
      }

      .icon {
        height: 0.1389rem;
        width: auto;
      }
    }
  }

  .loginBg {
    // border: 1px solid red;
    flex: 1;
    // height: 1080px;
    // border: 1px solid red;
    // background-color: #182c79;
    background-image: url("../assets/images/login.png");
    background-repeat: no-repeat;
    background-size:100% auto;
    background-position:0 1.3889rem;
    display: flex;
    // align-items: center;
    justify-content: right;

    .loginTitle {
      margin-top: .2778rem;
      padding: .1389rem;
      height: .0694rem;
      line-height: .0694rem;
      border-radius:.0347rem;
      background-color: #f0f0f5;
      a {
        text-decoration: none;
        color: #000000;
      }
    }
  }

  // 验证码弹框
  /deep/ .el-dialog {
    width: 3.9861rem;
    height: 1.5556rem;
    left: 50%;
    top: 35%;
    position: absolute;
    margin-left: -1.9861rem;
    margin-top: -0.2847rem !important;

    h2 {
      display: inline-block;
      font-weight: bold;
      font-size: 0.125rem;
    }

    .phone {
      margin-bottom: 0.125rem;
      width: 2.9722rem;
      border-radius: 0.0208rem;
      font-size: 0.0833rem;

      .el-input__inner {
        height: 0.2083rem;
        background: rgb(230, 230, 230);
        color: rgb(170, 170, 170);
        border: 1px solid rgb(170, 170, 170);
      }
    }

    .code {
      width: 1.9167rem;
      height: 0.2083rem;
      border-radius: 0.0208rem;
      font-size: 0.0833rem;

      .el-input__inner {
        height: 0.2083rem;
        background: rgb(230, 230, 230);
        color: rgb(170, 170, 170);
        border: 1px solid rgb(170, 170, 170);
      }
    }

    .getcode {
      padding: 0rem;
      margin-left: 0.0833rem;
      width: 0.9167rem;
      height: 0.2083rem;
      line-height: 0.2083rem;
      color: rgb(217, 30, 28);
      background: white;
      border: 1px solid rgb(217, 30, 28);
    }

    .el-dialog__header {
      padding: 0rem;
    }

    .el-dialog__body {
      padding: 0.3056rem 0rem 0.25rem 0.125rem;
      box-sizing: border-box;
    }

    // // 登录、关闭 按钮
    .btnGroup {
      margin-top: 0.2639rem;
      display: flex;
      justify-content: center;

      .el-button {
        padding: 0rem;
        width: 0.3472rem;
        height: 0.2361rem;
        color: rgb(217, 30, 28);
        border: 1px solid rgb(217, 30, 28);
      }

      .el-button:nth-child(2) {
        margin-left: 0.1389rem;
      }
    }
  }
}

// 激活项的样式
.active {
  color: #599ef8;
  background: #fff;
  border-bottom: 1px solid #599ef8;
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue